module.exports = __webpack_public_path__ + "static/media/etat-sieste-blue.fdd054fd.svg";